<template>
  <mdb-container fluid>
    <banner-small v-if="group" :group="group" title="Advanced Event Search"/>
    <div v-if="group">

      <data-table :actions="actions"
                  :additional-parameters="queryParams"
                  @handleAction="handleRowAction"
                  queryName="AdvancedEvent"/>
    </div>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbContainer

} from 'mdbvue';
import BannerSmall from "../group/BannerSmall"
import DataTable from "../common/DataTableAdvanced";

export default {
  name: 'Advanced-Event-Search',
  components: {
    BannerSmall,
    mdbContainer,
    DataTable
  },
  data() {
    return {
      events: [],
      reputationRules: null,
      showReputationModal: false,
      enteredFromPath: null,
      existingSearch: "",
      actions: [{name: "view", label: "View Details", class: 'text-success', color: "success", icon: "arrow-right"}],
      forceQuery: null,
      queryParams: {}
    }
  },

  computed: {
    group: function () {
      return this.$store.state.currentGroup
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
    settings: function () {
      return this.$store.state.settings
    }
  },
  async mounted() {
    document.title = "Event Search"
    this.queryParams.group = this.$route.params.id
    await this.$store.dispatch("setExecuting", true)
    await api.groupBasics(this.$route.params.id, "member")
    if (!this.group) {
      await this.$store.dispatch("setExecuting", false)
      await this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
      return
    }
    await this.$store.dispatch("setExecuting", false)
    api.trackGroupVisit(this.$route.params.id)

  },
  methods: {
    handleRowAction(row, action) {
      if (action == "view") {
        console.log("Go to ", row.id)
        this.$router.push("/event/show/" + row.id)
      }
    }

  }
};
</script>
